import { render } from "./PageBackground.vue?vue&type=template&id=785692b5&scoped=true"
import script from "./PageBackground.vue?vue&type=script&lang=js"
export * from "./PageBackground.vue?vue&type=script&lang=js"

import "./PageBackground.vue?vue&type=style&index=0&id=785692b5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785692b5"]])

export default __exports__